import RangeSliderContainer from '../../../Componant/BonusUi/RangeSlider/RangeSlider'

const RangeSlider = () => {
  return (
    <div className='page-body'>
      <RangeSliderContainer />
    </div>
  )
}

export default RangeSlider